import propTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Title, Subtitle, Col, ButtonLink } from './styles';

// Estado "sem Parceiro direto": a pessoa só tem vínculos que não dão contexto
// de Parceiro (ex.: só condomínio — síndico fica para fase 2). Nunca mostra
// dropdown vazio nem CTA de solicitar; só orienta a procurar o administrador.
const LoginWorkstationNoPartner = ({ setCurrentStep, steps }) => {
  const [t] = useTranslation('login');

  return (
    <Col>
      <Title>{t('workstation.no-partner.title')}</Title>
      <Subtitle>{t('workstation.no-partner.subtitle')}</Subtitle>
      <ButtonLink color="link" onClick={() => setCurrentStep(steps.email)}>
        {t('workstation.no-partner.back')}
      </ButtonLink>
    </Col>
  );
};

export default LoginWorkstationNoPartner;

LoginWorkstationNoPartner.propTypes = {
  setCurrentStep: propTypes.func.isRequired,
  steps: propTypes.object.isRequired,
};
